import { CARRIERS } from './constants';

/** Application input mode — either from Athena IN_WORK records or manual search. */
export type AppMode = 'inWork' | 'search';

/** Record representing an aircraft tail currently in maintenance. */
export interface TailRecord {
  tailNumber: string;
  carrier: string;
  ataCode: string;
  discrepancy: string;
  station: string;
}

/**
 * Carrier code to Bedrock Knowledge Base ID mapping.
 *
 * Built from CARRIERS (generated from the backend's authoritative JSON) so
 * adding a new carrier only requires editing backend/handlers/constants.json
 * plus the CARRIER_KB_ASSIGNMENT table in
 * scripts/generate-frontend-constants.py, then rerunning the generator.
 *
 * KB IDs come from REACT_APP_<kbEnvVar> environment variables at build time.
 * The CloudFormation stack exports the KB IDs and the build pipeline injects
 * them as REACT_APP_KB_* so the frontend never carries baked-in defaults.
 * An empty string is the documented fallback; downstream validation treats
 * empty IDs as missing.
 */
export const CARRIER_KNOWLEDGE_BASE_MAP: Record<string, string> =
  CARRIERS.reduce<Record<string, string>>((acc, { code, kbEnvVar }) => {
    acc[code] = process.env[`REACT_APP_${kbEnvVar}`] || '';
    return acc;
  }, {});

/** List of carrier codes available for manual search. */
export const SEARCH_CARRIERS: string[] = CARRIERS.map((c) => c.code);

/** Result from a single analysis section returned by the API. */
export interface SectionResult {
  section: string;
  title: string;
  content: string;
  sourceUris?: string[];
}

/** Presigned document reference returned by the document API. */
export interface DocumentReference {
  filename: string;
  url: string;
}

/** Parsed reference row extracted from section 9 markdown content. */
export interface ParsedReference {
  manual: string;
  taskNumber: string;
  title: string;
  revision: string;
}
